import React, { createContext, useContext, useState, useEffect } from "react";
import { getAdminTasksWithArchiveFilter } from "../service/api";

const ArchiveContext = createContext();

export const ArchiveProvider = ({ children }) => {
  const [archivedTasks, setArchivedTasks] = useState([]);
  const [loadingArchivedTasks, setLoadingArchivedTasks] = useState(false);

  const fetchArchivedTasks = async () => {
    setLoadingArchivedTasks(true);
    try {
      const res = await getAdminTasksWithArchiveFilter(true);
      if (res?.data?.data) {
        setArchivedTasks(res.data.data);
      } else {
        setArchivedTasks([]);
      }
    } catch (error) {
      console.error("Failed to fetch archived tasks", error);
      setArchivedTasks([]);
    } finally {
      setLoadingArchivedTasks(false);
    }
  };

  useEffect(() => {
    fetchArchivedTasks();
  }, []);

  return (
    <ArchiveContext.Provider
      value={{
        archivedTasks,
        loadingArchivedTasks,
        fetchArchivedTasks,
      }}
    >
      {children}
    </ArchiveContext.Provider>
  );
};

// Custom hook to use the context
export const useArchive = () => useContext(ArchiveContext);
